import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
const API_URL = process.env.REACT_APP_API_URL;
const LoginForm = ({ onSuccess }) => {
  const { t } = useTranslation();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(t(data.messageKey) || t('login_failed'));
      }
      login(data.user, data.token);
      if (onSuccess) {
        onSuccess();
      } else {
        // Rol tabanlı yönlendirme, eğer bağımsız sayfadaysa
        const userRole = data.user.role;
        if (userRole === 'admin' || userRole === 'support') navigate('/support/all-jobs', { replace: true });
        else if (userRole === 'translator') navigate('/dashboard/jobs', { replace: true });
        else navigate('/account/orders', { replace: true });
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-form">
      <p className="auth-form-prompt">{t('login_prompt')}</p>
      <form onSubmit={handleSubmit}>
        
        {/* DÜZELTME: "Floating label" yapısı eklendi */}
        <div className="form-group-auth floating-label">
            <input 
              id="modal-login-email" 
              type="email" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required 
              placeholder=" "
            />
            <label htmlFor="modal-login-email">{t('email_address')}</label>
        </div>

        <div className="form-group-auth floating-label">
            <input 
              id="modal-login-password" 
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required 
              placeholder=" "
            />
            <label htmlFor="modal-login-password">{t('password')}</label>
        </div>

        {error && <p className="auth-error">{error}</p>}
        
        <div className="form-options">
          <label className="auth-checkbox">
            <input type="checkbox" /> 
            <span>{t('remember_me')}</span>
          </label>
          <Link to="/forgot-password" className="auth-link">{t('forgot_password')}</Link>
        </div>

        <button type="submit" className="auth-submit-btn" disabled={isLoading}>
          {isLoading ? t('logging_in') : t('login_button')}
        </button>
      </form>
    </div>
  );
};

export default LoginForm;